<div fxFlex="grow" fxLayout="row" fxLayoutAlign="start none" fxLayoutGap="0.5em" class="plan-target-area" (click)="clicked.emit(plan)">
  <div
    fxLayout="column"
    class="status-icon status-icon--not-downloaded"
    *ngIf="!plan.isDownloaded"
    matTooltip="Plan is not available offline"
  >
    <mat-icon>cloud</mat-icon>
  </div>
  <div
    fxLayout="column"
    class="status-icon status-icon--not-synced"
    *ngIf="plan.isDownloaded && plan.isDirty"
    matTooltip="Plan has changes waiting to sync"
  >
    <mat-icon>cloud_upload</mat-icon>
  </div>
  <div fxLayout="column" class="status-icon status-icon--downloaded" *ngIf="plan.isDownloaded && !plan.isDirty">
    <mat-icon>check_circle</mat-icon>
  </div>

  <div fxFlex="grow" class="plan-info" fxLayout="column">
    <div class="plan-name" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <span>{{ plan.name }}</span>
      <mat-chip-list>
        <mat-chip *ngIf="!(isOwner() | async)" class="plan-isReviewer">Reviewer</mat-chip>
      </mat-chip-list>
      <mat-icon *ngIf="isPublished && (isOwner() | async)" matTooltip="Published">group</mat-icon>
    </div>
    <div>
      <span *ngIf="plan.startDate">
        {{ plan.startDate | date:"MMM d, yyyy" }}
      </span>
      <span *ngIf="plan.startDate && plan.numWeeks">|</span>
      <span *ngIf="plan.numWeeks">
        {{ plan.numWeeks }} weeks
      </span>
    </div>
    <div *ngIf="plan.notes" class="plan-notes">{{plan.notes}}</div>
    <div>Created by {{ creatorName }}</div>
  </div>
</div>

<mat-menu #planMenu="matMenu">
  <button mat-menu-item (click)="viewed.emit(plan)" *ngIf="isOnline && plan.isDownloaded">
    <mat-icon>visibility</mat-icon>
    <span>View</span>
  </button>
  <button mat-menu-item (click)="downloaded.emit(plan)" *ngIf="isOnline && !plan.isDownloaded">
    <mat-icon>cloud_download</mat-icon>
    <span>Download</span>
  </button>
  <button mat-menu-item (click)="edited.emit(plan)" *ngIf="(isOwner() | async)" [disabled]="!plan.isDownloaded">
    <mat-icon>create</mat-icon>
    <span>Edit</span>
  </button>
  <button mat-menu-item (click)="published.emit(plan)" *ngIf="(isOwner() | async)" [disabled]="!isOnline">
    <mat-icon>share</mat-icon>
    <span>Publish</span>
  </button>
  <button mat-menu-item (click)="shared.emit(plan)"  *ngIf="(isOwner() | async)" [disabled]="!isOnline">
    <mat-icon>send</mat-icon>
    <span>Share</span>
  </button>
  <button mat-menu-item (click)="copied.emit(plan)" [disabled]="!isOnline && !plan.isDownloaded">
    <mat-icon>filter_none</mat-icon>
    <span>Copy</span>
  </button>
  <button mat-menu-item (click)="deleted.emit(plan)" *ngIf="isOwner() | async" [disabled]="isPublished">
    <mat-icon>delete</mat-icon>
    <span>Delete</span>
  </button>
</mat-menu>

<button fxFlex="40px" mat-icon-button [matMenuTriggerFor]="planMenu">
  <mat-icon>more_vert</mat-icon>
</button>
